import store from "@/state/store";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/default"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        // Sin esto, los datos del usuario anterior seguían cacheados para quien
        // iniciara sesión después sin recargar la página.
        store.dispatch("empleado/limpiar");
        store.dispatch("cliente/limpiar");
        store.dispatch("negocio/limpiar");
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/pages/404",
    name: "Error-404",
    meta: { authRequired: true },
    component: () => import("./views/utility/404"),
  },
  {
    path: "/pages/500",
    name: "Error-500",
    meta: { authRequired: true },
    component: () => import("./views/utility/500"),
  },
  {
    path: "/usuarios/index",
    name: "Usuarios",
    meta: { authRequired: true },
    component: () => import("./views/usuarios/index"),
  },
  {
    path: "/usuarios/nuevoUsuario",
    name: "Agregar usuario",
    meta: { authRequired: true },
    component: () => import("./views/usuarios/nuevoUsuario"),
  },
  {
    path: "/usuarios/nuevaPoliza/:rfc",
    name: "Agregar Poliza",
    meta: { authRequired: true },
    component: () => import("./views/usuarios/nuevaPoliza"),
  },
  {
    path: "/empresas/index",
    name: "Agregar Negocios",
    meta: { authRequired: true },
    component: () => import("./views/empresas/index"),
  },
  {
    path: "/videos/index",
    name: "Videos",
    meta: { authRequired: true },
    component: () => import("./views/videos/index"),
  },
  {
    path: "/reconstructores/index",
    name: "Reconstructores",
    meta: { authRequired: true },
    component: () => import("./views/reconstructores/index"),
  },
  {
    path: "/actividades/index",
    name: "Espacios de los comercios",
    meta: { authRequired: true },
    component: () => import("./views/actividades/index"),
  },
  {
    path: "/plus/index",
    name: "Recnet Plus",
    meta: { authRequired: true },
    component: () => import("./views/plus/index"),
  },
  {
    path: "/suscripciones/index",
    name: "Suscripciones",
    meta: { authRequired: true },
    component: () => import("./views/suscripciones/index"),
  },
  {
    path: "/suscriptores/sin-membresia",
    name: "Sin membresía",
    meta: { authRequired: true },
    component: () => import("./views/suscriptores/sin-membresia"),
  },
  {
    path: "/bitacora/index",
    name: "Bitácora",
    meta: { authRequired: true, soloAdmin: true },
    component: () => import("./views/bitacora/index"),
  },

  // ===
  // Portal de clientes. Misma app y mismo despliegue que el panel, pero otra
  // zona: entra con cuenta de `app_usuarios`, no de `empleados`.
  // ===
  {
    path: "/portal/login",
    name: "portal-login",
    component: () => import("./views/portal/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // Si ya hay sesión de cliente, no tiene sentido volver a pedirla.
        if (store.getters["cliente/autorizado"]) {
          next({ name: "portal" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/portal/registro",
    name: "portal-registro",
    component: () => import("./views/portal/registro"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["cliente/autorizado"]) {
          next({ name: "portal" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/portal",
    name: "portal",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/inicio"),
  },
  {
    path: "/portal/sesiones",
    name: "portal-sesiones",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/sesiones"),
  },
  {
    path: "/portal/sesiones/:id",
    name: "portal-sesion",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/sesion"),
  },
  {
    path: "/portal/negocios",
    name: "portal-negocios",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/negocios"),
  },
  {
    path: "/portal/eventos",
    name: "portal-eventos",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/eventos"),
  },
  {
    path: "/portal/vacantes",
    name: "portal-vacantes",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/vacantes"),
  },
  {
    path: "/portal/cuenta",
    name: "portal-cuenta",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/cuenta"),
  },
  {
    path: "/portal/completar",
    name: "portal-completar",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/completar"),
  },

  // Área "Mi empresa". El guard sólo exige sesión de cliente; que además sea de
  // tipo comercio lo comprueba cada vista, porque es una regla de negocio y no
  // de enrutado.
  {
    path: "/portal/empresa",
    name: "portal-empresa",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/empresa"),
  },
  {
    path: "/portal/mis-eventos",
    name: "portal-mis-eventos",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/mis-eventos"),
  },
  {
    path: "/portal/mis-vacantes",
    name: "portal-mis-vacantes",
    meta: { clienteRequired: true },
    component: () => import("./views/portal/mis-vacantes"),
  },
];
